// File: ConsumerComplaint.jsx
import React from "react";

export default function ConsumerComplaint() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Consumer Complaint
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists in drafting and filing consumer complaints.
          </p>
          <p className="text-gray-700">
            Complete consumer dispute resolution including legal notice drafting, e-Jagriti portal filing, District/State/National Commission representation, evidence compilation, and compensation recovery.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Consumer complaint - legal/court documents) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/247851/pexels-photo-247851.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Consumer complaint filing and legal support"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for consumer court filings.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Invoice/receipt/warranty documents</li>
                <li>Complaint details and correspondence</li>
                <li>Proof of payment/delivery</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Legal accuracy and representation with proven success in consumer dispute resolution.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Legal Notice & Complaint Drafting
                </h3>
                <p className="text-gray-700 text-sm">
                  Consumer Protection Act compliant legal notices, e-Jagriti portal complaint filing, affidavit preparation, cause of action documentation, District/State/National Commission jurisdiction selection, and court fee calculations.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Evidence & Document Management
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete evidence compilation including defective goods photographs, service deficiency records, payment proofs, communication trails, expert witness coordination, and comprehensive annexure preparation.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Court Representation & Recovery
                </h3>
                <p className="text-gray-700 text-sm">
                  Full court representation before Consumer Commissions, ex-parte hearing management, compensation claim enforcement, execution proceedings, settlement negotiations, appeal support, and judgment enforcement.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
